import { Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { MediaFilter, MediaFilterMeta } from '@sim/media/models/media';

@Component({
  selector: 'app-media-filters',
  styleUrls: ['./media-filters.component.scss'],
  templateUrl: './media-filters.component.html',
})
export class MediaFiltersComponent extends BaseFiltersComponent<MediaFilter, FilterFieldsOptions<MediaFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, MediaFilterMeta);
  }

}
